import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaStar, FaArrowLeft, FaTag, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import './DealDetails.css';
import API_BASE_URL from './config';

const DealDetails = () => {
  const { dealId } = useParams();
  const [deal, setDeal] = useState(null);

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/deals/${dealId}`);
        const data = await response.json();
        if (response.ok) {
          setDeal(data);
        } else {
          setDeal(null);
        }
      } catch (error) {
        console.error('Error fetching deal:', error);
        setDeal(null);
      }
    };
    fetchDeal();
  }, [dealId]);

const handleRedeem = async () => {
  if (!deal || !deal._id) {
    alert("Deal data is missing.");
    return;
  }

  const userId = localStorage.getItem("userId");
  const source = localStorage.getItem("role") === "customer" ? "user_signup_details" : "users";

  if (!userId) {
    alert("User not logged in. Please log in to redeem.");
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/save-coupon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        source,
        dealId: deal._id
      })
    });

    const result = await response.json();

    if (response.ok) {
      alert(`✅ Payment successful!\nCoupon code: ${result.couponCode}`);
    } else {
      console.error(result.error || result);
      alert("❌ Failed to redeem coupon.");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("❌ Something went wrong.");
  }
};


  if (!deal) {
    return (
      <div className="deal-details not-found">
        <h2>Deal Not Found</h2>
        <Link to="/" className="back-link"><FaArrowLeft /> Back to Deals</Link>
      </div>
    );
  }

  return (
    <div className="deal-details-container">
      <div className="deal-details-header">
        <Link to="/" className="back-link"><FaArrowLeft /> Back to Deals</Link>
        <h2>{deal.title}</h2>
      </div>

      <div className="deal-details-content">
        <img
          className="deal-details-image"
          src={deal.image ? `/uploads/${deal.image}` : '/placeholder.jpg'}
          alt={deal.title}
        />

        <div className="deal-details-info">
          <h3 className="deal-name">{deal.title}</h3>
          <p className="merchant-info"><FaMapMarkerAlt /> {deal.merchantName} - {deal.merchantAddress}</p>
          <p className="deal-description">{deal.description}</p>
          <div className="deal-tags">
            <span><FaTag /> Category: {deal.category}</span>
            <span><FaClock /> Expires: {new Date(deal.endDate).toLocaleDateString('en-IN')}</span>
          </div>
          <div className="deal-rating">
            <FaStar className="star-icon" /> {deal.rating || 4.5} ({deal.reviews || 50} reviews)
          </div>
          <div className="deal-pricing">
            <span className="original-price">₹{deal.mrp}</span>
            <span className="discounted-price">₹{deal.customerBuyPrice}</span>
            <span className="discount-badge">{deal.discountValue}% Off</span>
          </div>
          {deal.discountValue && (
            <p className="perks-info">
              <FaTag /> Exclusive Perk: {deal.discountValue > 20 ? '🎁 Free Gift' : '💸 Additional 5% Off'} with this deal!
            </p>
          )}
          <button className="redeem-button" onClick={handleRedeem}>Buy Coupon</button>
        </div>
      </div>
    </div>
  );
};

export default DealDetails;